"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcTariffCodeBadge = exports.UcInvoiceStatusBadge = exports.UcInvoiceGroup = exports.TaxCodeSelector = exports.CurrencySelector = void 0;
const CurrencySelector_yaml_component_1 = __importDefault(require("./CurrencySelector.yaml?component"));
exports.CurrencySelector = CurrencySelector_yaml_component_1.default;
const TaxCodeSelector_yaml_component_1 = __importDefault(require("./TaxCodeSelector.yaml?component"));
exports.TaxCodeSelector = TaxCodeSelector_yaml_component_1.default;
const UcInvoiceGroup_yaml_component_1 = __importDefault(require("./UcInvoiceGroup.yaml?component"));
exports.UcInvoiceGroup = UcInvoiceGroup_yaml_component_1.default;
const UcInvoiceStatusBadge_yaml_component_1 = __importDefault(require("./UcInvoiceStatusBadge.yaml?component"));
exports.UcInvoiceStatusBadge = UcInvoiceStatusBadge_yaml_component_1.default;
const UcTariffCodeBadge_yaml_component_1 = __importDefault(require("./UcTariffCodeBadge.yaml?component"));
exports.UcTariffCodeBadge = UcTariffCodeBadge_yaml_component_1.default;
